export default "__VITE_ASSET__BTwq4sU$__"